import { memo, Fragment } from "react";
import { ShowStatus } from "@quantizr-engineering/common/types/show";
import { STATUS_CONFIG } from "../utils/showStatus";

const getStatusColor = (status: ShowStatus): string =>
  STATUS_CONFIG[status]?.color ?? "bg-[#E5E6E6]";

const getStatusStep = (status: ShowStatus): number =>
  STATUS_CONFIG[status]?.step ?? 0;

interface StatusStepsProps {
  currentStatus?: ShowStatus;
}

const StatusStepper = memo(({ currentStatus }: StatusStepsProps) => {
  const steps = Object.entries(STATUS_CONFIG);

  if (!currentStatus) {
    return null;
  }
  return (
    <div className="flex items-center w-full">
      {steps.map(([status, config], index) => (
        <Fragment key={config.step}>
          <div
            className={`w-4 h-4 rounded-full ${
              status === currentStatus ||
              config.step <= getStatusStep(currentStatus)
                ? getStatusColor(currentStatus)
                : "bg-[#E5E6E6]"
            }`}
          />
          {index < steps.length - 1 && (
            <div className="flex-1 px-1">
              <div
                className={`h-[2px] ${
                  STATUS_CONFIG[currentStatus].step >= steps[index + 1][1].step
                    ? STATUS_CONFIG[currentStatus].color
                    : "bg-[#E5E6E6]"
                }`}
              />
            </div>
          )}
        </Fragment>
      ))}
    </div>
  );
});

export default StatusStepper;
